import React from 'react'
import LabelTitleText from 'components/shared/LabelTitleText'
import classnames from 'classnames/bind'
import ResourceCardDetails from 'src/components/shared/ResourceCardDetails'
import css from './styles.module.scss'

const cx = classnames.bind(css)

const ResourceCards = ({ className, intro, cards }) => {
  return (
    <div className={cx(className)}>
      <LabelTitleText className={css.intro} {...intro} />
      <div className={css.grid}>
        {cards &&
          cards.map((card, index) => (
            <ResourceCardDetails key={index} {...card} />
          ))}
      </div>
    </div>
  )
}

ResourceCards.defaultProps = {}

export default ResourceCards
